export default {
    namespaced: true,
    state: { 
        countries: null,
        shiftTypes: null,
        targets: null

    },
    getters: {
		getShiftType: (state) => (id) =>{
			let shiftType = null;
			if(state.shiftTypes !== null){
				state.shiftTypes.map((shift) => {
					if(shift.id === id) {
						shiftType = shift;
					}
				})
			}
			// CHECK IF SHIFTYPE EXISTS ELSE RETURN NULL
			return shiftType;
        }
    },
    mutations: {

    },
    actions: {
        async getDefaultData({rootGetters, dispatch, commit }){

            if(rootGetters['user/isApproved']){
                dispatch('getShiftTypes');
            }
            dispatch('getTargets');
            dispatch('getCountries')
        },
        async getShiftTypes({ dispatch, commit, state }){
            if(state.shiftTypes === null){
                try{
                    let shiftTypes = await this._vm.$axios.get('shifts/types');
                    state.shiftTypes = shiftTypes.data.data;
                }catch(e){
                    console.error('Could not retrieve shiftTypes');
                    throw error('Could not retrieve shiftTypes');
                    
                }
            }
        },
        async getCountries({ dispatch, commit, state }){
            if(state.countries === null){
                try{
                    let countries = await this._vm.$axios.get('countries');
                    state.countries = countries.data.data;
                }catch(e){
                    console.error('Could not retrieve countries');
                }
            }
        },
        async getTargets({ dispatch, commit, state }){
            if(state.targets === null){
                try{
                    let targets = await this._vm.$axios.get('targets');
                    state.targets = targets.data.data;
                }catch(e){
                    console.error('Could not retrieve targets');
                }
            }
        },
    }
  

}


// WEBPACK FOOTER //
// ./src/store/modules/dataStore.js